import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/eventSubmissionStore';
import Layout from './../layout/Layout';
import AppContainer from 'containers/AppContainer';
import CheckoutWizard from 'containers/CheckoutWizardContainer';
import { StripeProvider } from 'react-stripe-elements';


const CheckoutApp = (props) => (
  <Provider store={configureStore(props)}>
    <Layout>
      <AppContainer>
        <StripeProvider apiKey={props.stripe_key}>
          <CheckoutWizard/>
        </StripeProvider>
      </AppContainer>
    </Layout>
  </Provider>
);

export default CheckoutApp;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/startup/CheckoutApp.jsx